import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, CompassIcon } from 'lucide-react';
interface HomeHeroProps {
  onExplore: () => void;
}
export function HomeHero({
  onExplore
}: HomeHeroProps) {
  return <header className="relative isolate min-h-[720px] overflow-hidden bg-[#26404a] text-white sm:min-h-[780px]" data-id="element-257" data-mp="246hhhiqutdbz">
      <img src="https://cdn.magicpatterns.com/uploads/veM2YoZZbXGQqfZwnhFXzy/Banff_Calgary_Alberta.jpg" alt="Turquoise mountain lake surrounded by Canadian Rockies" className="absolute inset-0 h-full w-full object-cover" data-id="element-258" data-mp="2952k1otkw93l" />
      <div className="absolute inset-0 bg-[#19333b]/55" data-id="element-259" data-mp="2n4ljzuc8ke4t" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[#19333b] via-[#19333b]/35 to-transparent" data-id="element-260" data-mp="2n41zq6z45dnm" />

      <nav className="relative mx-auto flex max-w-7xl items-center justify-between px-5 py-6 sm:px-8" data-id="element-261" data-mp="3fszfa2bxwwco">
        <a href="#top" aria-label="Pitch Better home" className="block w-24 sm:w-28" data-id="element-262" data-mp="3kjpl1goa317w">
          <img src="https://cdn.magicpatterns.com/uploads/fMsRRTxoKvaahMiQP4PDJ6/PitchBetterLogo.jpg" alt="Pitch Better" className="block w-full mix-blend-screen" data-id="element-263" data-mp="3kliv75y3o3kn" />
        </a>
        <a href="#vote" className="rounded-full border border-white/40 bg-white/10 px-4 py-2 text-sm font-600 backdrop-blur transition hover:bg-white/20" data-id="element-264" data-mp="xnapmx9sd9yg">
          Cast your vote
        </a>
      </nav>

      <motion.div initial={{
      opacity: 0,
      y: 28
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative mx-auto flex max-w-5xl flex-col items-center px-5 pb-20 pt-28 text-center sm:pt-36" data-id="element-265" data-mp="17l7706tbh150">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-700 uppercase tracking-[0.18em] backdrop-blur" data-id="element-266" data-mp="1gk2b9dcsw15o">
          <CompassIcon className="h-3.5 w-3.5 text-[#e6bf6a]" data-id="element-267" data-mp="3ifukmpmgzuer" /> 2026 Board Gathering
        </span>
        <p className="font-serif text-lg italic text-[#f5e4b6] sm:text-xl" data-id="element-268" data-mp="3ee9cfhkvs4aw">A considered escape for connected leadership</p>
        <h1 className="mt-3 max-w-4xl font-display text-5xl font-500 leading-[0.97] tracking-tight sm:text-7xl lg:text-8xl" data-id="element-269" data-mp="1man894d2eb6v">
          2026 Board Retreat
        </h1>
        <h2 className="mt-5 font-serif text-2xl font-normal italic sm:text-4xl" data-id="element-270" data-mp="1r8ewnoei3f6b">
          Help Us Choose Our Next Destination
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-7 text-white/85 sm:text-lg" data-id="element-271" data-mp="20ao60ay192i4">
          Your voice matters. Explore each destination, review our proposed retreat agenda, and choose where we’ll gather to connect, collaborate, and recharge.
        </p>
        <button onClick={onExplore} className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#d9b45d] px-7 py-4 font-700 text-[#233c37] shadow-lg transition hover:bg-[#f0d486]" data-id="element-272" data-mp="2a0zn6z6q986y">
          Explore destinations <ArrowDownIcon className="h-4 w-4" data-id="element-273" data-mp="2nzz2hg8coaqg" />
        </button>
      </motion.div>
    </header>;
}